import React, { createContext, useState } from 'react';

export type ModuleContextType = {
  moduleProperties?: any;
  intersected?: boolean | null;
  moduleType: string;
  moduleGlobalId: any;
  moduleTitle?: string;
  isWebview?: boolean;
};

type ModuleContextProps = {
  moduleContext: ModuleContextType | undefined;
  setModuleContext: React.Dispatch<
    React.SetStateAction<ModuleContextType | undefined>
  >;
};

type ModuleContextProviderProps = {
  value: ModuleContextType;
  children: React.ReactNode;
};

type ModuleContextPropsValidated = {
  moduleContext: ModuleContextType;
  setModuleContext: React.Dispatch<React.SetStateAction<ModuleContextType>>;
};

export const ModuleContext = createContext<ModuleContextProps>({
  moduleContext: undefined,
  setModuleContext: () => {},
});

export const ModuleContextProvider= ({
  children,
  value,
}: ModuleContextProviderProps) => {
  const [moduleContext, setModuleContext] = useState<
    ModuleContextType | undefined
  >(value);

  React.useEffect(() => {
    setModuleContext(value);
  }, [value]);

  return (
    <ModuleContext.Provider
      value={{
        moduleContext,
        setModuleContext,
      }}
    >
      {children}
    </ModuleContext.Provider>
  );
};

export const useModuleContext = (): ModuleContextPropsValidated => {
  const context = React.useContext(ModuleContext);

  if (!context || !context.moduleContext) {
    throw new Error('No host context found. Please setup the ModuleContext');
  }

  return context as ModuleContextPropsValidated;
};
